import styled from 'styled-components';

const ChannelListBackgroundContainer = styled.div`
  z-index: 1;
`;

export default ChannelListBackgroundContainer;
